import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryKeysClient } from 'common/clients/query-key.client';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  createCustomerService,
  getCounterpartyCustomersListService,
  updateCustomerService,
} from '../services/customers.service';
import {
  TCreateCustomersReqData,
  TCustomerAccountsListResData,
  TCustomersListReqParams,
  TCustomersListResData,
  TUpdateCustomersReqData,
} from '../types/customers.types';

export const useGetCounterpartyCustomersListQuery = (
  counterpartyGUID: string,
  params?: TCustomersListReqParams,
  options?: any,
): UseQueryResult<TCustomersListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CustomerQueryKeys].getCustomersList(counterpartyGUID, params),
    ...options,
  });

export const useGetCounterpartyCustomersListQuery_MultiRole = (
  counterpartyGUID: string,
  branchGUID: string,
  params?: TCustomersListReqParams,
  hasAccessForAllBranches?: boolean,
  options?: any,
): UseQueryResult<TCustomersListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CustomerQueryKeys]
      .getCustomersList_MultiRole(counterpartyGUID, branchGUID, params, hasAccessForAllBranches),
    ...options,
  });

export const useGetCounterpartyCustomersMutation = (): any =>
  useMutation({
    mutationFn: (data: {
      counterpartyGUID: string;
      params: TCustomersListReqParams;
    }) =>
      getCounterpartyCustomersListService(data.counterpartyGUID, data.params),
  });

export const useGetCustomerAccountsListQuery = (
  counterpartyGUID: string,
  customerGUID: string,
  options?: any,
): UseQueryResult<TCustomerAccountsListResData> =>
  useQuery({
    ...queryKeysClient[EQueryKeys.CustomerQueryKeys].getCustomerAccountsList(counterpartyGUID, customerGUID),
    ...options,
  });

export const useCustomersListQuery = (
  counterpartyGUID: string,
  params: TCustomersListReqParams,
  options?: any,
): UseQueryResult<TCustomersListResData> => useQuery({
  ...queryKeysClient[EQueryKeys.CustomerQueryKeys].getCustomersList(counterpartyGUID, params),
  ...options,
});

export const useGetCreateCustomerMutation = (): any =>
  useMutation({
    mutationFn: (data: {
      counterpartyGUID: string;
      requestData: TCreateCustomersReqData;
    }) => createCustomerService(data.counterpartyGUID, data.requestData),
  });

export const useUpdateCreateCustomerMutation = (): any =>
  useMutation({
    mutationFn: (data: {
      counterpartyGUID: string;
      customerGUID: string;
      requestData: TUpdateCustomersReqData;
    }) => updateCustomerService(data.counterpartyGUID, data.customerGUID, data.requestData),
  });
